<template>
    <el-container>
        <el-header style="height:120px;">
            <el-form :inline="true" :model="fromLog" ref="fromLog" class="demo-form-inline">
                <el-row :gutter="20">
                    <el-col>
                        <td-permission :roles="roles" style="float:right;">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.CURSYS')">
                                    <td-select
                                        v-model="fromLog.sysFlg"
                                        :placeholder="$t('common.PLEASE_SELECT')"
                                        @change="btnClickQuery()"
                                        :options="this.sysAndFlgList"
                                        keys="sSysFlg"
                                        text="sName"
                                        :pageSize="selectPageSize"
                                        :clearable="false"
                                    >
                                    </td-select>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <td-permission :oneOfPermissions="permissionsQuery">
                            <div slot="havePermission">
                                <el-form-item :label="$t('common.NAME')" prop="sCaption">
                                    <td-input v-model="fromLog.sName"></td-input>
                                </el-form-item>
                                <el-form-item :label="$t('common.OPERATION_LEVEL')" prop="sOperationLevel">
                                    <td-select v-model="fromLog.sType" :options="options" keys="value" text="label" :multiple="multiple" :collapse-tags="collapse" @change="queryPageList"></td-select>
                                </el-form-item>
                            </div>
                        </td-permission>
                        <el-form-item>
                            <td-button type="primary" :loading="loading" @click="btnClickQuery" :permissions="permissionsQuery">{{ $t('common.QUERY') }}</td-button>
                            <td-button type="button" @click="btnAdd" :permissions="permissionsAdd">{{ $t('common.ADD') }} </td-button>
                            <td-button type="button" @click="btnDeleteBatch" :permissions="permissionsDelete">{{ $t('common.DELETE') }} </td-button>
                            <td-button type="button" @click="btnDistribute" :permissions="permissionsEdit">{{ $t('common.LEVEL_DISTRIBUTE') }} </td-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-header>
        <el-main>
            <!-- 加载表格 -->
            <td-table
                :columns="columns"
                :dataSource="tableData"
                :pageSize="pageSize"
                :currentPage="currentPage"
                :total="total"
                ref="listTypeInfo"
                :rowKey="rowKey"
                @handleSizeChange="handleSizeChange"
                @currentChange="currentChange"
                :permissions="permissionsQuery"
                :hasLoading="loading"
            ></td-table>
            <!-- 加载dialog -->
            <dialog-TypeInfo
                v-if="dialogTypeVisible"
                :isAddData="isAddData"
                :dialogTypeVisible="dialogTypeVisible"
                :editItem="editItem"
                :sSysFlg="this.fromLog.sysFlg"
                :title="title"
                ref="addOrModifyInfo"
                @logTypeDialogClose="logTypeDialogClose"
                @submit="submit"
                :iAllowFinetune="iAllowFinetune"
            ></dialog-TypeInfo>
            <dialog-ReLevelInfo
                v-if="dialogReLevelVisible"
                :dialogReLevelVisible="dialogReLevelVisible"
                :title="title"
                :items="items"
                :sSysFlg="this.fromLog.sysFlg"
                @logReLevelDialogClose="logReLevelDialogClose"
                @submit="submit"
            ></dialog-ReLevelInfo>
            <dialog-UseInfo v-if="dialogUseDefineVisible" :dialogUseDefineVisible="dialogUseDefineVisible" :showItem="useShowItem" :title="useTitle" @logDialogClose="useDialogClose"></dialog-UseInfo>
        </el-main>
    </el-container>
</template>

<script>
import dialogTypeInfo from './components/dialogTypeInfo.vue';
import dialogReLevelInfo from './components/dialogReLevelInfo.vue';
import typeApi from './assets/api.js';
import levelApi from '../logLevelManager/assets/api.js';
import dialogUseDefineVue from './components/dialogUseDefine.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-TypeInfo': dialogTypeInfo,
        'dialog-ReLevelInfo': dialogReLevelInfo,
        'dialog-UseInfo': dialogUseDefineVue
    },
    created() {
        if (this.$common.systemInfo.systemId) {
            this.fromLog.sysFlg = this.$common.systemInfo.systemId;
        } else {
            this.fromLog.sysFlg = 'PG';
        }
        let param = {};
        typeApi.getSysList(JSON.stringify(param), response => {
            if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                this.$log.error('sys/getSysList', response.data.statusMessage);
            }
            this.sysList = response.data.content;
            this.sysAndFlgList = [];
            for (let index = 0; index < this.sysList.length; index++) {
                let element = this.sysList[index];
                this.sysAndFlgList.push({ sName: element.sName + '：' + element.sSysFlg, sSysFlg: element.sSysFlg });
            }
        });
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {
        this.queryLevel();
        this.btnClickQuery(); // 进行页面初始化数据的加载
    },
    // 定义数据
    data() {
        return {
            fromLog: { sCaption: '', sysFlg: '' },
            permissionsQuery: ['operationType:view'],
            permissionsDelete: ['operationType:del'],
            permissionsAdd: ['operationType:add'],
            permissionsEdit: ['operationType:edit'],
            editItem: '',
            sysList: [],
            sysAndFlgList: [],
            listMqInfo: [],
            dialogTypeVisible: false,
            dialogRelatedSetVisible: false,
            dialogReLevelVisible: false,
            dialogUseDefineVisible: false, // 使用说明
            tableData: [],
            isAddData: true, // 是否为添加数据
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            loading: false,
            options: [],
            rowKey: 'sId',
            multiple: true,
            collapse: true,
            roles: ['admin'],
            selectPageSize: 10,
            iAllowFinetune: true,
            columns: [
                {
                    prop: 'sCaption',
                    label: 'common.NAME'
                },
                {
                    prop: 'sPermission',
                    label: 'common.LABEL'
                },
                {
                    prop: 'sOperationLevelCaption',
                    label: 'common.OPERATION_LEVEL'
                },
                {
                    prop: 'sDescribe',
                    label: 'common.DESCRIPTION'
                },
                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '300',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: this.permissionsEdit },
                                    on: {
                                        click: () => {
                                            this.btnExit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: this.permissionsDelete },
                                    on: {
                                        click: () => {
                                            this.btnDelete(params.row.sId);
                                        }
                                    }
                                },
                                this.$t('common.DELETE')
                            ),
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small' },
                                    on: {
                                        click: () => {
                                            this.btnShowUseDefine(params.row);
                                        }
                                    }
                                },
                                this.$t('common.INSTRUCTIONS')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.btnClickQuery();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.btnQuery();
        },
        // 查询数据
        queryPageList(data) {
            this.$nextTick(function() {
                if (data && data.length > 1 && data.indexOf('all') > -1) {
                    if (data[0] === 'all') {
                        data.splice(0, 1);
                        this.fromLog.sType = data;
                    } else {
                        this.fromLog.sType = ['all'];
                    }
                }
            });
        },
        // 查询数据
        btnQuery() {
            this.loading = true;
            let param = {
                sCaption: this.fromLog.sName,
                sSysFlg: this.fromLog.sysFlg,
                sOperationLevelIds: this.fromLog.sType,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                isPage: true
            };
            if (this.fromLog.sType && this.fromLog.sType.indexOf('all') > -1) {
                param.sOperationLevelIds = null;
            }
            typeApi.queryOperationType(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.loading = false;
                    this.$log.error('logTypeManager/queryOperationType', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('logTypeManager/queryOperationType', response.data.statusMessage);
                    this.loading = false;
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
                this.loading = false;
            });
        },

        // 添加
        btnAdd() {
            this.title = this.$t('common.ADD') + this.$t('common.OPERATE_TYPE'); // 标题
            this.isAddData = true;
            this.dialogTypeVisible = true;
        },

        // 编辑
        btnExit(row) {
            this.editItem = row;
            this.title = this.$t('common.EDIT') + this.$t('common.OPERATE_TYPE');
            this.isAddData = false;
            this.dialogTypeVisible = true;
            this.iAllowFinetune = row.iAllowFinetune;
        },
        // 删除接口
        btnDelete(sId) {
            this.$confirm(this.$t('userInfo.DELETE_THIS_OPERATION_TYPE'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    let param = { sId: sId };
                    typeApi.deleteOperationType(param, response => {
                        if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('logTypeManager/deleteOperationType', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.DELETE_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {});
        },
        // 级别分配
        btnDistribute() {
            this.items = this.$refs.listTypeInfo.getSelectAllRows();
            if (!this.items.length) {
                this.$message({ showClose: true, message: this.$t('userInfo.SELECT_ASSIGN_OPE_TYPE'), type: 'warning' });
                return;
            }
            this.title = this.$t('common.LEVEL_DISTRIBUTE');
            this.dialogReLevelVisible = true;
        },
        // 组件关闭需要调用的方法
        submit() {
            this.btnClickQuery();
        },
        // 点击查询按钮查询
        btnClickQuery() {
            this.currentPage = 1;
            this.btnQuery();
            this.queryLevel();
        },
        // 关闭添加页面
        logTypeDialogClose() {
            this.dialogTypeVisible = false;
        },
        // 关闭级别分配页面
        logReLevelDialogClose() {
            this.dialogReLevelVisible = false;
        },
        // 批量删除
        btnDeleteBatch() {
            this.$log.info('btnDeleteBatch');
            let params = this.getSelects();
            if (!params.length) {
                this.$message({ showClose: true, message: this.$t('userInfo.SELECT_OPE_TYPE'), type: 'warning' });
                return;
            }
            this.$confirm(this.$t('userInfo.DELETE_OPERATION_TYPE'), this.$t('common.TIPS'), {
                confirmButtonText: this.$t('common.SURE'),
                cancelButtonText: this.$t('common.CANCEL'),
                type: 'warning'
            })
                .then(() => {
                    typeApi.deleteOperationTypeBatch(JSON.stringify(params), response => {
                        if (response.status !== this.$common.login.RESPONSE_STATUS) {
                            this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                            this.$log.error('logTypeManager/deleteOperationTypeBatch', response.data.statusMessage);
                            return;
                        }
                        this.$message({ showClose: true, message: this.$t('common.OPERATION_SUCCESS'), type: 'success' });
                        this.submit();
                    });
                })
                .catch(() => {});
        },
        // 获取级别主键
        getSelects() {
            let ids = this.$refs.listTypeInfo.getSelectAllRows();
            let content = [];
            for (let i = 0; i < ids.length; i++) {
                let temValue = ids[i];
                let select = { sId: temValue.sId };
                content.push(select);
            }
            return content;
        },
        // 使用说明
        btnShowUseDefine(row) {
            this.useShowItem = row;
            this.dialogUseDefineVisible = true;
            this.useTitle = this.$t('common.OPERATE_TYPE') + row.sCaption + this.$t('common.INSTRUCTIONS');
        },
        // 组件关闭需要调用的方法
        useDialogClose() {
            this.dialogUseDefineVisible = false;
        },
        //查询操作级别
        queryLevel() {
            let param = {
                sSysFlg: this.fromLog.sysFlg,
                isPage: false
            };
            levelApi.queryOperationLevel(JSON.stringify(param), response => {
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    this.$log.error('logTypeManager/queryOperationLevel', response);
                    return;
                }
                if (response.data.statusCode && response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$log.error('logTypeManager/queryOperationLevel', response.data.statusMessage);
                    return;
                }
                let levelList = response.data.content;
                this.options = [
                    {
                        value: 'all',
                        label: this.$t('common.ALL')
                    }
                ];
                if (levelList) {
                    for (let i = 0; i < levelList.length; i++) {
                        let temValue = levelList[i];
                        let item = {
                            value: temValue.sId,
                            label: temValue.sCaption
                        };
                        this.options.push(item);
                    }
                }
            });
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
</style>
